<template>
    <div v-if="ticketEventList && ticketEventList.length > 0">
        <div class="el-divider el-divider--horizontal ticket-reply-switch-bar">
            <div class="el-divider__text is-center">
                <span class="ticket-reply-switch-item"
                    title="显示所有工单回复和操作记录"
                    :class="{'ticket-reply-switch-item-active' : 'all' == ticketEventFilter}"
                    @click="showAll">全部</span>
                <span class="ticket-reply-switch-item"
                    title="仅显示工单回复,不显示其他操作记录"
                    :class="{'ticket-reply-switch-item-active' : 'reply' == ticketEventFilter}"
                    @click="showReply">仅回复</span>
                <span class="ticket-reply-switch-item"
                    title="仅显示有附件的工单回复"
                    :class="{'ticket-reply-switch-item-active' : 'attachment' == ticketEventFilter}"
                    @click="showAttachment">附件</span>
                <span class="ticket-reply-switch-item"
                    title="仅显示有表单的记录"
                    :class="{'ticket-reply-switch-item-active' : 'form' == ticketEventFilter}"
                    @click="showForm">表单</span>
            </div>
        </div>

        <!-- 回复列表 -->
        <div v-for="(flow, index) in ticketEventListFiltered"
            :key="flow.id"
            :class="['ticket_event_0',{'private_ticket_event':!flow.visible}]">
            <p class="ticket-event-style">
                <span class="color-orange" style="display:inline-block;width:35px;">#{{ ticketEventListFiltered.length - index }}</span>
                由
                <TicketUser :userId="flow.dealUserId"/>
                于
                <span :title="flow.createdAt">{{ flow.createdAt|ticketTime }}</span>

                <!-- 客户短信息 -->
                <TicketOrigin v-model="flow.originId"/>

                <!-- 公开私密切换开关 -->
                <TicketEventVisibleSwitch :ticketEvent="flow"/>

                <span class="color-orange padding-l-xs">{{ flow.operateContent }}</span>

                <span v-if="flow.operateContent != '添加回复'"></span>

                <template v-if="flow.assignUserId">
                    ，指派给 
                    <TicketUser :userId="flow.assignUserId"/>
                </template>

                <template v-if="!!flow.noticeUserList && flow.noticeUserList.length > 0">
                    ，抄送给 
                    <div v-for="(n, index) in flow.noticeUserList" :key="n.id">
                        <span class="color-orange">{{ n.noticeUserGroupName }} {{ n.noticeUserName }}</span>
                        <span v-if="index < flow.noticeUserList.length-1">,</span>
                    </div>
                </template>
            </p>

            <!-- 回复正文 -->
            <p class="ticket-img-style ticket-event-style ticket-content" v-if="flow.orderRemark" v-html="flow.orderRemark.remarkContent"></p>

            <!-- 表单 -->
            <TicketTaskForm
                v-if="!!flow.taskId"
                :fullScreen="true"
                :taskId="flow.taskId"
                @change="onTicketTaskFormChange"/>

            <!-- 附件列表 -->
            <div class="ticket-img-style ticket-event-style" v-if="flow.orderRemark && flow.orderRemark.attachmentList.length > 0">
                <div v-for="l in flow.orderRemark.attachmentList" :key="l.id">
                    <el-image v-if="isImage(l)" :src="l.filePath"></el-image>
                    <audio v-else-if="isAudio(l)" controls :src="l.filePath" preload="meta"></audio>
                    <video v-else-if="isVideo(l)" controls :src="l.filePath" width="640" height="360"></video>
                    <a v-else :href="l.filePath+'?attname='+l.fileName" target="_blank" title="点击下载 回复附件[45]">
                        <i class="el-icon-download"></i>
                        <span>{{ l.fileName }}</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- 撑高 -->
        <div style="height:300px;"></div>

        <TicketFormOperationBar ref="TicketFormOperationBar"
            @submit="onTicketFormOperationBarSubmit"/>
    </div>
</template>

<script>
export default {
  name: "TicketEventList",

  props: ['ticketEventList'],

  data() {
      return {
          ticketEventListFiltered: [],
          ticketEventFilter: 'all'
      }
  },

  watch: {
      ticketEventList() {
        this.filterTicketEvent();
      }
  },

  mounted() {
      this.filterTicketEvent();
  },

  methods : {
    filterTicketEvent() {
        if( !this.ticketEventList || "all" == this.ticketEventFilter) {
            this.ticketEventListFiltered = this.ticketEventList || [];

            this.$forceUpdate();
            return;
        }

        if ( "reply" == this.ticketEventFilter ) {
            this.ticketEventListFiltered = this.ticketEventList.filter(e => !!e.orderRemark);

            this.$forceUpdate();
            return;
        }

        if ( "attachment" == this.ticketEventFilter ) {
            this.ticketEventListFiltered = this.ticketEventList.filter(e => {
                return !!e.orderRemark && !!e.orderRemark.attachmentList && e.orderRemark.attachmentList.length > 0;
            });

            this.$forceUpdate();
            return;
        }

        if ( "form" == this.ticketEventFilter ) {
            this.ticketEventListFiltered = this.ticketEventList.filter(e => !!e.taskId);

            this.$forceUpdate();
            return;
        }

        // 应该不会到这里
        this.ticketEventListFiltered = this.ticketEventList || [];
        this.$forceUpdate();
    },

    showForm() {
        this.ticketEventFilter = "form";
        _message("仅显示表单");
        this.filterTicketEvent();
    },

    showAll() {
        this.ticketEventFilter = "all";
        _message("显示所有工单回复和操作记录");
        this.filterTicketEvent();
    },

    showReply() {
        this.ticketEventFilter = "reply";
        _message("仅显示工单回复,不显示其他操作记录");
        this.filterTicketEvent();
    },

    showAttachment() {
        this.ticketEventFilter = "attachment";
        _message("仅显示有附件的工单回复");
        this.filterTicketEvent();
    },

    onTicketFormOperationBarSubmit() {
        this.$emit('ticketFormOperationBarSubmit', null);
    },

    onTicketTaskFormChange( _e ) {
        _e.ticketNo = this.$route.query.orderId;
        this.$refs.TicketFormOperationBar.onTicketTaskFormChange( _e );
    }
  }
}
</script>

<style>
.ticket-event-style {
    word-break: break-all;
    padding-left : 20px;
    margin : 5px 0;
    padding-right: 20px;
}

.ticket_event_0 {
    padding : 5px 0;
    border-bottom: 2px solid #f5f6fb;
}

.private_ticket_event {
    background: #f0f3f5;
    border-top-color: white!important;
}

.ticket_event_0:hover {
    box-shadow: 1px 1px 5px 2px #c4c4c4;
}
.ticket-reply-switch-bar {
    margin-bottom: 30px;
}
.el-divider {
    background-color: #f5f6fb;
}
.el-divider--horizontal {
    height: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketEventList.vue